<template>
	<section class="schedule-box">

		<!-- Шапка -->
		<div class="header">
			<!-- Название месяца -->
			<div class="hours-col">
				<div class="hour monthName">
					{{monthName | threeLetters}}
				</div>
			</div>

			<!-- Левая стрелка -->
			<div class="content-col left_arrow">
				<img src="../../assets/img/svg/agenda-left.svg" class="days_decor" @click="clickLeft">
			</div>
			<!-- Конец Левая стрелка -->
			<!-- Дни -->
			<div class="content-col" :style="{'width': calcWidth(dayCount)}" v-for="day in daysArray">
				<div class="day days_decor day_shadow transition" :class="{'current': day == today}">
					{{[day, 'DD-MM-YYYY dd'] | moment('DD dd')}}
				</div>
			</div>

			<!-- Правая стрелка -->
			<div class="content-col right_arrow">
				<img src="../../assets/img/svg/agenda-right.svg" class="days_decor" @click="clickRight">
			</div>
			<!-- Конец Правая стрелка -->
		</div>

		<!-- Надпись -->
		<div class="doctor-title">
			<p v-if="doctor._id">
				{{doctor.user_last_name}} {{doctor.user_first_name | one}} {{doctor.user_middle_name | one}}
			</p>
			<p v-else>Выберите доктора</p>
		</div>

		<!-- Тело календаря -->
		<div class="time-line">
			<!-- Временной столебец -->
			<div class="hours-col main">
				<div class="hour" v-for="time in timeLine">
					<p class="time_color" v-show="time != '00:00'">{{time}}</p>
					<div class="workTime" v-if="time == '08:00'"></div>
				</div>
			</div>

			<!-- Столбци дней -->
			<div class="content-col" :style="{'width': calcWidth(dayCount)}" v-for="day in daysArray">
				<div class="day" @mouseover="dragOver($event)" v-for="time in timeLine"
						 :class="{'not-work-time': !checkWorkTime(time, day)}"
						 @click="clickScheduler(day, calcTime(time, $event))">&nbsp;
				</div>
			</div>

			<!-- Визиты доктора-->
			<!--TODO here is bad code. need to fix-->
			<div v-for="event in events" :style="calcEventStyles(event)"
					 v-if="isDoctor && event.status !== 'canceled'"
					 @click="clickEvent(event)"
					 @mousedown="dragStart(event, $event)" @mousemove="dragStart(event, $event)"
					 @contextmenu.prevent @contextmenu="openStatus(event, this.posX = $event.clientX, this.posY = $event.clientY)" class="event pointer">
				{{[event.begin, 'X'] | moment('HH:mm')}}
				{{event.users[0].last_name}}
				{{event.users[0].first_name | one}}
				{{event.users[0].middle_name | one}}
				{{event.description}}
			</div>

			<!-- Визиты вошедшего пациента-->
			<!--TODO here is bad code. need to fix-->
            <!--<div v-for="event in events" :style="calcEventStyles(event)"
					 v-if="!isDoctor && userId == event.users[0]._id && event.status !== 'canceled'"
					 @click="clickEvent(event)" @mousedown="dragStart(event, $event)" @mousemove="dragStart(event, $event)"
					 class="event pointer">
				{{[event.begin, 'X'] | moment('HH:mm')}}
				{{event.users[0].last_name}}
				{{event.users[0].first_name | one}}
				{{event.users[0].middle_name | one}}
				{{event.description}}
			</div>-->

			<!-- Визиты других пациентов-->
			<!--TODO here is bad code. need to fix-->
			<!--<div v-for="event in events" v-if="!isDoctor && userId != event.users[0]._id && event.status !== 'canceled'"
					 :style="calcEventStyles(event)"
					 class="event pointer"></div>-->

			<!-- Текущее время -->
			<div class="current-time" :style="{'top': currentTime.top + 'px'}" v-if="currentTime.time">
				<div class="time">{{currentTime.time}}</div>
				<div class="line"></div>
			</div>
		</div>
    <!--Drop Menu-->

    <!--Drop Menu End-->
	</section>

</template>

<script>
	import moment from 'moment';
	import _ from 'underscore';
	import Time from '@/common/UTC';

	let toNormalDays = {
		"0": "1",
		"1": "2",
		"2": "3",
		"3": "4",
		"4": "5",
		"5": "6",
		"6": "0",
	};

	export default {
		name: 'LargeScheduler',
		props: ['isDoctor'],
		filters: {
			threeLetters(val) {
				if(val) return val[0] + val[1] + val[2]
			},
		},
		computed: {
			clinicId() {
				return this.$route.query.clinic
			},
			userId() {
				return this.$storage.get('user')
			},
			daysArray() {
				let start = moment(this.start, 'DD-MM-YYYY dd'), arr = [];

				for (let i = 0; i < this.dayCount; i++) {
					arr.push(start.add((i) ? 1 : 0, 'days').format('DD-MM-YYYY dd'));
				}

				return arr;
			},
			timeLine() {
				let resArr = [];
				let now = moment(this.schedulerTime.start);
				let maxLines = (this.schedulerTime.end.hour + 1 - this.schedulerTime.start.hour) * 2;

				for (let i = 0; i < maxLines; i++) {
					resArr.push(now.format('HH:mm'));
					now.add(30, 'minutes');
				}

				return resArr;
			},
			monthName() {
				if(this.start) {
					return moment(this.start, 'DD-MM-YYYY').format('MMM')
				}
			},
		},
		mounted() {
			this.$event.connect('updateEvents', id => this.initData(id));

			this.$event.connect('updateDayOfCalendar', (day) => {
				this.start = moment(day).format('DD-MM-YYYY');
				this.initData(this.doctor._id);
			});

			this.$event.connect('updateDayCount', (days) => {
				this.dayCount = days;
				this.initData(this.doctor._id);
			});

			this.$event.connect('moveEvent', (visit) => {
				this.isMove = true;
				this.tmpVisit = visit;
			});

			this.$event.connect('sendInquiry', (visit) => {
				this.isInquiry = true;
				this.tmpVisit = visit;
			});

			this.start = moment().format('DD-MM-YYYY');
			this.getCurrentTime();
		},
		data() {
			return {
				today: moment().format('DD-MM-YYYY dd'),
				start: '',
				dayCount: 5,
				events: [],
				posX: 54,
				posY: 33,
				currentTime: {
					top: '',
					time: '',
				},
				doctor: {},
				schedule: [],
				specialSchedule: {
					special: [],
					vacation: [],
				},
				config: {
					not_confirmed: '#68cae0',
					confirmed: '#06a6c9',
					came: '#f3a50a',
					completed: '#28db74',
					canceled: '#999999',
					not_appeared: '#eb774a',
				},
				isMove: false,
				isInquiry: false,
				showContext: false,
				tmpVisit: {},
				draggedEvent: {},
				schedulerTime: {
					start: {
						hour: 7,
						minute: 0,
					},
					end: {
						hour: 21, // max 23
						minute: 59,
					},
				},
			}
		},
		methods: {
			initData(id) {
				if(!id) {
					return false;
				}

				if(id === this.doctor._id) {
					this.getSpecialSchedule(this.doctor)
						.then(this.getEvents(this.doctor));
				} else {
					this.getWorker(id)
						.then(worker => this.getSpecialSchedule(worker))
						.then(worker => this.getEvents(worker));
				}
			},
			getEvents(doctor) {
				return this.$store.dispatch('agenda/byDate', this.getRequestObjectForAgenda(doctor))
					.then(events => this.events = this.concat(events));
			},
			getSpecialSchedule(worker) {
				return this.$store.dispatch('special/list', {worker_ids: [worker._id]})
					.then(special => this.setSpecial(special.data))
					.then(() => worker);
			},
			getWorker(id) {
				if(!id) return false;

				return this.$api.get('worker/' + id)
					.then(response => {
						this.doctor = response;
						this.schedule = response.schedule || [];
						this.isInquiry = (response.can === 'by_request');

						return response;
					});
			},

			calcEventStyles(event) {
				if(event.priority)
					return {
						'top': this.calcPosition(event.begin) + 'px',
						'height': this.calcHeight(event.begin, event.end) + 'px',
						'width': this.calcEventWidth(this.dayCount, event.priority),
						'background': this.config[event.status],
						'left': this.calcLeft(event.begin, event.priority) + 'px',
						'z-index': event.priority,
						'box-shadow': (event.priority <= 1) ? 'none' : '0 0 3px gray',
					};

				return {
					'top': this.calcPosition(event.begin) + 'px',
					'height': this.calcHeight(event.begin, event.end) + 'px',
					'width': this.calcEventWidth(this.dayCount),
					'background': this.config[event.status],
					'left': this.calcLeft(event.begin) + 'px',
				}
			},

			getRequestObjectForAgenda(doctor) {
				return {
					begin: moment(this.daysArray[0], 'DD-MM-YYYY').format('YYYY-MM-DD'),
					end: moment(this.daysArray[this.daysArray.length - 1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
					worker_ids: [doctor._id],
				}
			},
			isShownCurrentTime() {
				const current = moment().unix();
				const start = moment(this.schedulerTime.start).unix();
				const end = moment(this.schedulerTime.end).unix();
				return start <= current && current <= end;
			},
			getCurrentTime() {

				this.scrollTop = this.scrollTop.bind(this);

				// height/24hours*60 minutes = 2400*1440
				let l = 1.666666666666667;

				setInterval(() => {
					if(this.isShownCurrentTime()) {
						this.currentTime = {
							top: moment().diff(moment(this.schedulerTime.start), "minutes") * l - 8,
							time: moment().format("HH:mm"),
						}
					}
				}, 1500);

				setTimeout(this.scrollTop(this.currentTime.top), 1700);
			},
			clickScheduler(day, time) {
				console.log('Клик! Пам-пам')

				if(!this.isClosedTime(day)) {
					this.$event.toast('i', "Вы не можете сделать запись на прошлый день или на 6 месяцев позднее сегодня");

					if(this.isMove) {
						this.tmpVisit = {};
						this.isMove = false;
					}

					return false
				}

				if(this.isMove) {
					this.moveEvent(day, time, this.tmpVisit);
				} else if(this.isInquiry) {
					this.tmpVisit.begin = moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X');
					this.tmpVisit.isInquiry = true;
					this.$event.send('openEditModal', _.clone(this.tmpVisit), this.doctor);


					this.tmpVisit = {};
					this.isInquiry = false;
				} else {
					this.$event.send('openEditModal', {
						begin: moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X'),
					}, this.doctor);
				}
			},
			clickEvent(event) {
				this.$event.send('openDetailsModal', event);
			},

			/**
			 * Moving event to new date and time
			 * @param {string} day
			 * @param {string} time
			 * @param {object} event
			 */
			moveEvent(day, time, event) {
				let begin = moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X');
				let duration = moment(event.end, 'X').diff(moment(event.begin, 'X'), 'minutes');

				this.$store.dispatch('agenda/update', {
					id: event._id,
					begin: begin,
					end: moment(begin, 'X').add(duration, 'minutes').format('X'),
				}).then(() => {
					this.$event.send('updateEvents', this.doctor._id);
					this.isMove = false;
					this.tmpVisit = {};
				});
			},

			/**
			 * concat all events from all days to one array for render
			 * @param {Array} days
			 * @returns {Array}
			 */
			concat(days) {
				return _.uniq(_([]).concat(..._.toArray(days)));
			},

			/**
			 * Getting one day
			 * @param day
			 * @returns {boolean}
			 */
			replaceEvents(day) {
				if(!day.length) {
					return false;
				}

				day = _.sortBy(day, "begin");

				_.map(day, (item, index) => {
					let arrForSend;

					arrForSend = this.compareVisitWithOther(index, day);

					this.changeSizeOfEvents(arrForSend, true);

					delete day[index];
				})
			},

			/**
			 * Takes one visit and compare with other visits in array
			 * @param index {number | string}
			 * @param day
			 * @returns {Array}
			 */
			compareVisitWithOther(index, day) {
				let arr = [], id;

				for (let i = index + 1; i <= day.length - 1; i++) {
					id = this.compareTwoEvents(day[index], day[i]);

					if(id) {
						this.changeSizeOfEvents([day[index]._id], false);
						arr.push(id)
					}
				}

				return arr;
			},

			/**
			 * Compares two visits
			 * @param one {object} - first visit
			 * @param two {object} - second visit
			 * @returns {*}
			 */
			compareTwoEvents(one, two) {
				if(!one || !two) {
					return false
				}

				if(one.begin <= two.begin && two.begin <= one.end) {
					return two._id
				} else if(one.begin <= two.end && two.end <= one.end) {
					return two._id
				}

				return false
			},

			changeSizeOfEvents(eventIds) {
				if(!eventIds.length)
					return false
			},

			calcPosition(start) {
				const step = 15; // step in minutes (can be changed, but it should recalc number of pixels below)
				const pixelCount = 25; // height of step in pixels (changing of step also changes pixel count)

				if(start) {
					// needs in this record style because we need time without date and seconds
					let currentTime = moment(start, 'X').format('HH:mm');
					let startTime = moment(this.schedulerTime.start);
					return moment(currentTime, 'HH:mm').diff(startTime, 'minutes') / step * pixelCount;
				}
			},
			calcHeight(start, end) {
				if(start && end) {
					return moment(end, 'X').diff(moment(start, 'X'), "minutes") * 1.666666666 - 5;
				}
			},
			calcWidth(dayCount) {
				return 'calc((100% - 52px)/' + dayCount + ')';
			},
			calcEventWidth(dayCount, d) {

				d -= 1;
				d /= 20;
				d = 1 - d;

				if(d) {
					return 'calc(((100% - 52px)/' + dayCount + '*0.90)*' + d + ')';
				}

				return 'calc((100% - 52px)/' + dayCount + '*0.90)';
			},
			calcLeft(start, d) {
				if(!start) return false;

				let currentTime, startTime, difference, x, oneBlock, result, margin;

				currentTime = moment(start, 'X');
				startTime = moment(this.start, 'DD-MM-YYYY');
				difference = currentTime.diff(startTime, 'days');
				x = document.getElementsByClassName('time-line')[0].offsetWidth;
				oneBlock = (x - 52) / this.dayCount;

				if(d) {
					margin = oneBlock - (oneBlock / (1 + (d / 5)));
				}

				result = (oneBlock * difference) + 52;

				return result
			},
			calcTime(time, e) {
				let part = Math.floor(e.offsetY / 25);
				let newMinutes = part * 15;

				return moment(time, 'HH:mm').add(newMinutes, 'minutes').format('HH:mm');
			},
			checkWorkTime(time, day) {
//				if(this.doctor.can !== 'yes' && this.doctor.can !== 'by_request') {
//					return false;
//				}

				return !this.checkVacations(this.specialSchedule.vacation, day) && this.checkSchedule(time, day);
			},
			checkVacations(vacations, day) {
				let validDay = moment(day, 'DD-MM-YYYY');

				for (let i = 0; i <= vacations.length - 1; i++) {
					let begin = moment(vacations[i].begin, 'X');
					let end = moment(vacations[i].end, 'X');

					if(validDay.isSameOrAfter(begin, 'day') && validDay.isSameOrBefore(end, 'day')) {
						return true;
					}
				}

				return false;
			},
			checkSchedule(time, day) {
				for (let i = 0; i <= this.specialSchedule.special.length - 1; i++) {
					let record = this.specialSchedule.special[i];

					if(moment(record.begin, 'X').format('DD-MM-YYYY') === day) {
						return this.checkSpecialDays(record, time, day)
					}
				}

				return this.checkUsualSchedule(this.schedule, time, day)
			},

			checkSpecialDays(record, time, day) {
				let validTime = moment(time + ' ' + day, 'HH:mm DD-MM-YYYY');
				let begin = moment(record.begin, 'X');
				let end = moment(record.end, 'X');

				return !_.contains(record.type, 'not_work') && (validTime.isSameOrAfter(begin, 'minute') && validTime.isBefore(end, 'minute'));
			},
			checkUsualSchedule(schedule, time, day) {
				if (schedule.lenght === 0) {
					console.warn('Schedule argument is invalid');
					return false;
				}

				let validTime = moment(time, 'HH:mm');
				let dayNumber = moment(day, 'DD-MM-YYYY').format('e');
				let scheduleDay = schedule[toNormalDays[dayNumber]];

				if (!scheduleDay) {
					return false;
				}

				if (!!scheduleDay.period && scheduleDay.period.length === 0) {
					return false;
				}

				for (let i = 0; i <= scheduleDay.period.length - 1; i++) {
					let record = scheduleDay.period[i];
					let begin = moment(Time.toLocal(record.begin), 'HH:mm');
					let end = moment(Time.toLocal(record.end), 'HH:mm');

					return (validTime.isSameOrAfter(begin, 'minute') && validTime.isBefore(end, 'minute'))
				}

				return false;
			},
			clickLeft() {
				this.start = moment(this.start, "DD-MM-YYYY").subtract(this.dayCount, 'days').format('DD-MM-YYYY');
				this.getEvents(this.doctor);
			},
			clickRight() {
				this.start = moment(this.start, "DD-MM-YYYY").add(this.dayCount, 'days').format('DD-MM-YYYY');
				this.getEvents(this.doctor);
			},
			scrollTop(margin) {
				let el = document.getElementsByClassName('time-line')[0];
				el.scrollTop = margin - 200;
			},
			dragStart(event,) {
				this.draggedEvent = event;
			},
			dragOver(e) {
//				console.info(e.target.offsetTop)
			},
			dragEnd() {
				this.draggedEvent = {};
			},
			isClosedTime(day) {
				let todayMoment = moment(this.today, 'DD-MM-YYYY');
				let selectedDayMoment = moment(day, 'DD-MM-YYYY');
				let lastDay = moment(this.today, 'DD-MM-YYYY').add(184, 'days');

				return (selectedDayMoment.isSameOrAfter(todayMoment, 'days') && selectedDayMoment.isBefore(lastDay, 'days'));
			},
			setSpecial(array) {
				this.specialSchedule = {
					vacation: [],
					special: [],
				};

				_.each(array, record => {
					if(moment(record.begin, 'X').format('DD') !== moment(record.end, 'X').format('DD')) {
						this.specialSchedule.vacation.push(record);
					} else {
						this.specialSchedule.special.push(record);
					}
				});
			},

			openStatus(event, posX, posY) {
                var model = {event, posX, posY};
				this.$event.send('openStatusModal', model);
                console.log(model);
			},
		},
		beforeDestroy() {
			this.$event.disconnect(['updateEvents', 'updateDayOfCalendar', 'updateDayCount', 'moveEvent', 'sendInquiry']);
		},
	}
</script>

<style lang="scss" scoped>
	body {
		background: #eee;
	}

	.schedule-box {
		position: relative;
		height: 100%;
		overflow: hidden;
	}

	.header {
		padding-top: 5px;
		position: relative;
		height: 51px;
		top: 0;
		left: 0;
		right: 0;
		background-color: #06a6c9;
		z-index: 55;
	}

	.time-line {
		width: 100%;
		height: calc(100% - 84px);
		position: relative;
		overflow: auto;
		background: #fff;
		margin-top: -1px;
		user-select: none;
	}

	.doctor-title {
		position: relative;
		height: 33px;
		background: #68cae0;
	}

	.doctor-title p {
		text-align: center;
		color: #ffffff;
		font-size: 16px;
		padding: 4px;
		border-bottom: 1px solid #fff;
	}

	.time-block {
		color: #999;
		height: 50px;
		width: 45px;
		text-align: center;
		padding: 0 5px;
		border-right: 1px solid #d6d6d6;
		float: left;
	}

	.content-block {
		height: 49px;
		width: calc(100% - 56px);
		float: right;
		border-top: 1px solid #d6d6d6;
	}

	.time-block > .time {
		margin-top: -10px;
	}

	.event-container {
		display: block;
	}

	.event {
		position: absolute;
		top: 32%;
		left: 58px;
		width: 80%;
		background: #888;
		border-radius: 0;
		height: 30px;
		color: white;
		line-height: 16px;
		box-shadow: 1px 1px 6px 0 #999999;
        overflow: hidden;
	}

	.hours-col {
		float: left;
		width: 52px;
		color: #ffffff;

		.hour {
			box-sizing: border-box;
			width: 100%;
			padding: 0 5px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			text-transform: uppercase;
		}
	}

	.hours-col.main {
		.hour {
			line-height: 0;
		}
	}

	.content-col {
		float: left;
		height: 50px;
		line-height: 50px;
		text-align: center;
	}

	.hour.not-work-time {
		background: #999;
	}

	.day {
		height: 50px;
		text-align: center;
		width: 100%;
		box-sizing: border-box;
		box-shadow: 0 0 1px 0 #06c6a9;
		color: #ffffff;
		font-weight: 700;
        text-transform: capitalize;
	}

	.not-work-time {
		background: #e8e8e8;
		// pointer-events: none; // Позволить врачам делать запись на нерабочее время
	}

	.current {
		/*background: #FE3B2C;*/
		color: #FE3B2C;
		box-shadow: 0 0 2px 0 #FE3B2C;
	}

	.days_decor {
		width: 48px;
		height: 32px;
		border-radius: 50%;
		line-height: 32px;
		display: inline-block;
		cursor: pointer;
	}

	.current-time {
		position: absolute;
		width: 100%;
		height: 16px;

		.time {
			color: red;
			width: 51px;
			float: left;
			text-align: center;
			background: #fff;
		}

		.line {
			height: 1px;
			float: left;
			line-height: 16px;
			background: red;
			width: calc(100% - 55px);
			margin-top: 8px;
		}
	}

	.day_shadow {
		/*box-shadow: 0 0 0 1px #ffffff;*/
	}

	.current {
		box-shadow: 0 0 0 1px #FE3B2C;
	}

	.time_color {
		color: #9e9e9e;
	}

	.left_arrow {
		& > .days_decor {
			position: absolute;
			left: 46px;
			height: 25px;
			top: 17px;
		}
	}

	.right_arrow {
		& > .days_decor {
			position: absolute;
			right: -5px;
			height: 25px;
			top: 17px;
		}
	}

</style>



// WEBPACK FOOTER //
// LargeScheduler.vue?138cbcb2